import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// CATALAN
import caCommon from './locales/ca/common.json';
import caClaimFollowUp from './locales/ca/claimFollowUp.json';
import caSurvey from './locales/ca/survey.json';

// ESPANOL
import esCommon from './locales/es/common.json';
import esClaimFollowUp from './locales/es/claimFollowUp.json';
import esSurvey from './locales/es/survey.json';

// INGLES
import enCommon from './locales/en/common.json';
import enClaimFollowUp from './locales/en/claimFollowUp.json';
import enSurvey from './locales/en/survey.json';

// FRANCES
import frCommon from './locales/fr/common.json';
import frClaimFollowUp from './locales/fr/claimFollowUp.json';
import frSurvey from './locales/fr/survey.json';

import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
    ca: {
        common: caCommon,
        survey: caSurvey,
        claimFollowUp: caClaimFollowUp,
    },
    es: {
        common: esCommon,
        survey: esSurvey,
        claimFollowUp: esClaimFollowUp,
    },
    en: {
        common: enCommon,
        survey: enSurvey,
        claimFollowUp: enClaimFollowUp,
    },
    fr: {
        common: frCommon,
        survey: frSurvey,
        claimFollowUp: frClaimFollowUp,
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "es",
        supportedLngs: ["ca", "en", "es"],
        ns: ['common', 'survey'],
        interpolation: {
            escapeValue: false,
        },
        debug: false,
        detection: {
            order: ["localStorage", "cookie", "navigator"],
            caches: ["localStorage", "cookie"]
        },
    });

export default i18n;
